import { SectionTitle } from "$components/section";
import { Grid, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  section: {
    paddingTop: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    textAlign: "left",
  },
  subtitle: {
    color: theme.palette.text.secondary,
  },
  content: {
    paddingLeft: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "revert",
    },
  },
}));

export const FormSection: FCwC<{
  title: string;
  subtitle?: React.ReactNode;
  classes?: Record<string, string>;
}> = ({ title, subtitle, children, classes: overrideClasses }) => {
  const classes = { ...useStyles(), ...overrideClasses };

  return (
    <Grid container className={classes.section}>
      <Grid item md={4}>
        <SectionTitle>{title}</SectionTitle>
        {!!subtitle && <div className={classes.subtitle}>{subtitle}</div>}
      </Grid>
      <Grid
        container
        item
        justifyContent="flex-end"
        md={8}
        className={classes.content}
      >
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </Grid>
  );
};
